const FALLBACK = "LAK";

/** ສະກຸນທີ່ບໍ່ໃຊ້ທົດສະນິຍົມໃນການສະແດງ (ເຊັນ ກີບ) */
function isIntegerDisplayCurrency(code: string): boolean {
  return code === "LAK";
}

/**
 * ສະແດງຍອດເງິນຕາມສະກຸນເງິນເອກະສານ (ISO 4217).
 * LAK ສະແດງເປັນຈຳນວນເຕັມ ບໍ່ມີ .00
 */
export function formatDocumentCurrency(
  amount: number,
  currencyCode?: string | null,
): string {
  const code = (currencyCode?.trim() || FALLBACK).toUpperCase();
  const integerDisplay = isIntegerDisplayCurrency(code);
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: code,
      minimumFractionDigits: integerDisplay ? 0 : 2,
      maximumFractionDigits: integerDisplay ? 0 : 2,
    }).format(amount);
  } catch {
    return integerDisplay
      ? `${Math.round(amount)} ${code}`
      : `${amount.toFixed(2)} ${code}`;
  }
}
